document.addEventListener('DOMContentLoaded', () => {
    const mapWrapper = document.querySelector('.OfficesMap');
    const tooltip = document.getElementById('svg-tooltip');

    if (!mapWrapper || !tooltip) return;

    mapWrapper.addEventListener('mouseover', e => {
        const path = e.target.closest('path[title]');
        if (!path) return;

        tooltip.textContent = path.getAttribute('title');
        tooltip.style.opacity = '1';

        if (path.dataset.url) {
            path.style.cursor = 'pointer';
        }
    });

    mapWrapper.addEventListener('mousemove', e => {
        if (tooltip.style.opacity !== '1') return;

        tooltip.style.left = e.clientX + 'px';
        tooltip.style.top = e.clientY + 'px';
    });

    mapWrapper.addEventListener('mouseout', e => {
        const path = e.target.closest('path[title]');
        if (!path) return;

        tooltip.style.opacity = '0';
        path.style.cursor = '';
    });

    mapWrapper.addEventListener('click', e => {
        const path = e.target.closest('path[data-url]');
        if (!path) return;

        const url = path.dataset.url;
        if (!url) return;

        window.location.href = url;
    });
});
